import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton } from '@mui/material';
import React from 'react';
import { ConsultancyModalProps } from '../../../interfaces/Credits';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const ConsultancyModal: React.FC<ConsultancyModalProps> = ({ open, onClose, onGoToBilling }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <Typography variant="h6" align="center">{t('consultancy:modal_title')}</Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" align="center">
                    {t('consultancy:modal_subtitle')}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: '#E9495A',
                        color: '#fff',
                        '&:hover': { backgroundColor: "#E6263B" }
                    }}
                    onClick={onGoToBilling}
                >
                    {t('consultancy:modal_button')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConsultancyModal;